import { render, staticRenderFns } from "./DesignCanvasRatio.vue?vue&type=template&id=15cfaad2&scoped=true"
import script from "./DesignCanvasRatio.vue?vue&type=script&lang=js"
export * from "./DesignCanvasRatio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15cfaad2",
  null
  
)

export default component.exports